import { Component, Input } from '@angular/core';

/**
 * Kopiowanie lokalizacji — buduje link Google Maps z lat/lng i oddaje go wspólnej
 * afordancji. Cała mechanika (schowek, komunikat, podpowiedź, ptaszek potwierdzenia)
 * należy do <app-copy-button>; tutaj zostaje wyłącznie budowa adresu.
 *
 * UWAGA: inputy lat/lng to PRAWDZIWE współrzędne geograficzne. W części widoków
 * pola w danych są historycznie zamienione (systemowy swap lat/lng) — przekazuj
 * te same wyrażenia, które w danym widoku idą do [latitude]/[longitude] agm-mapy.
 */
@Component({
  selector: 'app-copy-location',
  template: `
    <app-copy-button [value]="link" copyKind="location" [size]="size"></app-copy-button>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
    }
  `]
})
export class CopyLocationComponent {
  @Input() lat: number | string;
  @Input() lng: number | string;
  @Input() size = 16;

  /**
   * Pusty łańcuch przy braku współrzędnych — <app-copy-button> nie renderuje się
   * dla wartości, której nie ma sensu kopiować, więc nie trzeba tu własnego *ngIf.
   */
  get link(): string {
    return this.hasCoords
      ? `https://www.google.com/maps?q=${Number(this.lat)},${Number(this.lng)}`
      : '';
  }

  private get hasCoords(): boolean {
    return this.isCoord(this.lat) && this.isCoord(this.lng);
  }

  private isCoord(value: number | string): boolean {
    return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
  }
}
